import React, { useState } from 'react'
import { Button, Heading, Text } from '@plurall/elo-beta'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'utils/constants'
import styles from './EmptyClasses.module.scss'

const EmptyClasses = () => {
  const [linkToRedirect, setLinkToRedirect] = useState(null)
  const navigate = useNavigate()

  if (linkToRedirect) {
    navigate(linkToRedirect)
  }

  return (
    <div className={styles.emptyClass}>
      <div className={styles.title}>
        <Heading element='h4'>Função de Professor:</Heading>
        <Text>Sua escola ainda não possui turmas.</Text>
      </div>
      <div className={styles.buttons}>
        <Button onClick={() => setLinkToRedirect(ROUTES.PERFIL_DADOS_ESCOLARES)}>Voltar</Button>
      </div>
    </div>
  )
}

export default EmptyClasses
